class OfficeController {
  constructor() {
  }
}

export default OfficeController;



// WEBPACK FOOTER //
// ./client/app/components/offices/office/office.controller.js